import styled from 'styled-components';
import { asRem } from '@missionme/mime_elements';
import { TTheme } from '@missionme/mime_elements/dist/esm/Components';

export default styled.span`
  &.h1 {
    font-family: Poppins-Light;
    font-size: ${asRem(32)};
    line-height: ${asRem(42)};
    margin-bottom: ${({ theme }: TTheme) => asRem(theme.spacing.two)};

    @media (min-width: ${({ theme }: TTheme) => theme.breakpoints.md}) {
      font-size: ${asRem(48)};
      line-height: ${asRem(58)};
    }

    @media (min-width: ${({ theme }: TTheme) => theme.breakpoints.lg}) {
      font-size: ${asRem(54)};
      line-height: ${asRem(64)};
      margin-bottom: ${({ theme }: TTheme) => asRem(theme.spacing.two)};
    }
  }
`;
